import { insertAdSlot, isCSR } from '../../common/utils';
// import { isMobile, isDesktop } from "react-device-detect";
import { useEffect } from 'react';
import { PAGEBUILDER_URLS } from '../Common/Constant';

export function AddScripts(props: any) {
    console.log("props : ", props);

    let {
        // headerScript,
        // bodyScript,
        compWidth,
        adSize,
        // bodyAdScript,
        // bodyAdMobileScript,
        userAgent,
        renderedAdHeight,
        renderedAdWidth
    } = props;

    // console.log("headerScript : " + headerScript);
    // console.log("bodyScript : " + bodyScript);
    // console.log("bodyAdScript : " + bodyAdScript);
    // console.log("bodyAdMobileScript : " + bodyAdMobileScript);
    // console.log("adSize : " + adSize);
    // console.log("userAgent : " + userAgent);
    // console.log("renderedAdHeight : " + renderedAdHeight);
    // console.log("renderedAdWidth : " + renderedAdWidth);

    const height = parseInt(adSize.split("*")[1]);

    // const [adSlotContent, setAdSlotContent] = useState<any>("");



    useEffect(() => {
        if (typeof window !== 'undefined' && window.gpEditor) {

            window.gpEditor.editor.on('component:selected', (component: any) => {
                if (component) {
                    setTimeout(() => {
                        const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                        if (trait && trait.el) {
                            // Show trait element if showAdSlot is true, hide otherwise
                            trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                        }
                    }, 200);
                }
            });

            const selected = window.gpEditor.getSelected();
            if (selected) {
                const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                if (trait && trait.el) {
                    // Show trait element if showAdSlot is true, hide otherwise
                    trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                }
            }
        }
    }, [props.showAdSlot, props.adSize]);


    // const adContainerRef = useRef<HTMLDivElement>(null);

    if (compWidth !== undefined && compWidth > 970) {
        adSize = `970*90`;
    }

    let completeBodyScript: any = "";

    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
        completeBodyScript = `
            <div class="container" style="display: flex; justify-content: center; align-items: center; max-width: 100%; min-height: ${height}px; background-color: #f0f0f0; margin: 0px auto;">
                <div class="ad-box">
                    Ad Slot
                </div>
            </div>`;
    } else if (isCSR()) {
        console.log("CSR Mode adscript");
        completeBodyScript = props?.data?.attributes?.adConfigurations;
    } else {
        console.log("SSR Mode adscript");

        // if(props.name && (props.name === "Ad Scripts Two Amp" || props.name === "Ad Scripts Amp" || props.name === "Ad Scripts Three Amp") || props.name === "Photo Show Two Amp" || props.name === "Photo Show Three Amp") {
        //     completeBodyScript = props?.data?.attributes?.adConfigurations;
        // } else {
        //     // completeBodyScript = `<div></div>`;
        //     completeBodyScript = props?.data?.attributes?.adConfigurations;
        // }
        completeBodyScript = props?.data?.attributes?.adConfigurations;
    } 

    /**
     * Need to pass userAgent to insertAdSlot to get the correct userAgent when isMobile  will get enabled from akamai.
     */
    let adSlotContentFinal = insertAdSlot(1, completeBodyScript, props.name, userAgent);
    // let adSlotContentFinal = insertAdSlot(1, completeBodyScript, props.name);

    // For Page Builder, return the placeholder div
    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
        return (
            <div 
                id="adslot_wrapper"
                style={{
                    height: renderedAdHeight,
                    width: renderedAdWidth,
                    display: "contents",
                    // overflow: "hidden",
                    // maxWidth: "100%"
                }}
                dangerouslySetInnerHTML={{ __html: completeBodyScript }}
            />
        );
    }

    console.log("completeBodyScript :: ", completeBodyScript);

    if(userAgent === "isMobile") {
        if(!completeBodyScript?.mobile[0]?.bodyScript) {
            return (
                <div id="adslot_wrapper_empty_mobile" style={{display: "none"}}></div>
            )
        }
    } else if(userAgent === "isDesktop") {
        if(!completeBodyScript?.desktop[0]?.bodyScript) {
            return (
                <div id="adslot_wrapper_empty_desktop" style={{display: "none"}}></div>
            )
        }
    }

    // For normal CSR and SSR, return the ad content
    return (
        <div    
            id="adslot_wrapper"
            style={{
                height: renderedAdHeight,
                width: renderedAdWidth,
                // display: "contents",
                // overflow: "hidden",
                maxWidth: "100%",
                margin: "0 auto",       
                textAlign: "center",  
                lineHeight: "60px"   
            }}
        >
            {adSlotContentFinal}
        </div>
    );
   

}


